import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatabaseDownstreamMetricsWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatabaseDownstreamMetricsWithoutPersonalSpaceQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  databases(filter: { id: $databaseId }) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
